import { useAnalytics } from "~/components/Analytics";
import { ButtonLink } from "~/ui-library/components/ButtonLink/ButtonLink";

export const ArticleAuthorContact: React.FC = () => {
  const { analyticsEnhancedTrack } = useAnalytics();
  const onClick = () => {
    analyticsEnhancedTrack("Content: Contact Us");
  };

  return (
    <div className="flex flex-col gap-s bg-gray-100 p-s print:hidden">
      <span>
        <strong className="font-bold">We want to hear from you.&nbsp;</strong>
        Reach out to this author or your Morning Consult team with any questions
        or comments.
      </span>

      <ButtonLink
        as="a"
        className="w-fit"
        href="mailto:pro@morningconsult.com"
        onClick={onClick}
        size="extraSmall"
        variant="primary"
      >
        Contact Us
      </ButtonLink>
    </div>
  );
};
